import React from 'react'
import graybarLogo from '../../assets/Graybar.png'
import './HeaderBar.scss'

/**
 *  Responsible for showing the Desktop version of the HeaderBar
 */
export default function HeaderBar() {
    return (
        <div className="nav-outer-container">
            <div id="nav-logo">
                <div id="logo-wrapper">
                        <img
                            src={graybarLogo}
                            alt="Graybar Logo"
                        />
                </div>
            </div>
        </div>
    )
}
